import React, { createContext, useContext, ReactNode } from "react";

interface ProcessOrderDetailsProviderProps {
  children: ReactNode;
  callback?: () => void;
  parentId: string;
  action: string;
}

interface ProcessOrderDetailsContextValue {
  callback?: () => void;
  parentId: string;
  action: string;
}

const ProcessOrderDetailsContext = createContext<
  ProcessOrderDetailsContextValue | undefined
>(undefined);

const ProcessOrderDetailsProvider: React.FC<
  ProcessOrderDetailsProviderProps
> = ({ children, callback, parentId, action }) => {
  return (
    <ProcessOrderDetailsContext.Provider value={{ callback, parentId, action }}>
      {children}
    </ProcessOrderDetailsContext.Provider>
  );
};

const useProcessOrderDetailsContext = (): ProcessOrderDetailsContextValue => {
  const context = useContext(ProcessOrderDetailsContext);
  if (!context) {
    throw new Error(
      "useProcessOrderDetailsContext must be used within an ProcessOrderDetailsProvider"
    );
  }
  return context;
};

export { ProcessOrderDetailsProvider, useProcessOrderDetailsContext };
